import { getFunctions, httpsCallable } from 'firebase/functions';
import { Timestamp, doc } from 'firebase/firestore';
import { onSnapshot } from './firestoreRead';
import { db } from '../firebase/firebaseConfig';

const call = async (name, data) => (await httpsCallable(getFunctions(), name)(data)).data;
const restaurar = ({ createdAtMillis, updatedAtMillis, ...d }) => ({ ...d,
  ...(Number.isFinite(createdAtMillis) ? { createdAt: Timestamp.fromMillis(createdAtMillis) } : {}),
  ...(Number.isFinite(updatedAtMillis) ? { updatedAt: Timestamp.fromMillis(updatedAtMillis) } : {}) });
export const consultarEntradaEscaner = (entradaId) => call('consultarEntradaEscaner', { entradaId });
export const consumirEntradaEscaner = (entradaId) => call('consumirEntradaEscaner', { entradaId });
export async function listarEntradasPrivadas(eventoId) {
  return (await call('listarEntradasReporte', { eventoId })).entradas.map(restaurar);
}
export function escucharReservasPrivadas(eventoId, rol, onData, onError, modulo = 'reservas') {
  // El contador no contiene datos privados. Cada cambio se resuelve por RPC,
  // que vuelve a comprobar Auth, perfil, permisos y ámbito en servidor.
  let active = true, generation = 0, running = false, pending = false, timer;
  let planoHuella, ultimoPlano;
  let subscriptions = [];
  const visible = () => document.visibilityState !== 'hidden';
  const refresh = async () => {
    if (!active || !visible()) return;
    if (running) { pending = true; return; }
    running = true; pending = false;
    const current = generation;
    try {
      const result = await call('obtenerMapaReservas', { eventoId, modulo, ...(planoHuella ? {planoHuella} : {}) });
      if (active && visible() && current === generation && !pending) {
        if (!result.planoSinCambios) ultimoPlano = result.plano;
        planoHuella = result.planoHuella;
        onData({
        plano: ultimoPlano, contextoRecinto: result.contextoRecinto,
        aplicacionesPaquetes: result.aplicacionesPaquetes,
        ocupacion: result.ocupacion, reservas: result.reservas.map(restaurar)
        });
      }
    } catch (e) { if (active && visible() && current === generation) onError(e); }
    finally {
      running = false;
      if (active && pending && visible()) schedule();
    }
  };
  const schedule = () => {
    if (!active || !visible()) return;
    pending = true;
    clearTimeout(timer);
    timer = setTimeout(refresh, 100);
  };
  const stop = () => {
    generation++; clearTimeout(timer); pending = false;
    subscriptions.forEach(unsubscribe => unsubscribe()); subscriptions = [];
  };
  const start = () => {
    if (!active || !visible() || subscriptions.length) return;
    const current = generation;
    const changed = snap => {
      // No usar el caché local como confirmación de disponibilidad.
      if (active && current === generation && !snap.metadata?.fromCache) schedule();
    };
    const failed = e => { if (active && current === generation) { stop(); onError(e); } };
    subscriptions = [
      onSnapshot(doc(db, 'controlReservas', eventoId), { includeMetadataChanges: true }, changed, failed),
      onSnapshot(doc(db, 'eventos', eventoId), { includeMetadataChanges: true }, changed, failed)
    ];
  };
  const visibility = () => { if (visible()) start(); else stop(); };
  document.addEventListener('visibilitychange', visibility);
  start();
  return () => { active = false; stop(); document.removeEventListener('visibilitychange', visibility); };
}

export const corregirReservaOwner = (datos) => call('corregirReservaOwner', datos);

export const operarReserva = datos => call('operarReserva', datos);
export const nuevaSolicitudReserva = () => typeof crypto?.randomUUID === 'function' ? crypto.randomUUID() : Array.from(crypto.getRandomValues(new Uint8Array(16)), x=>x.toString(16).padStart(2,'0')).join('');

export const listarEventosReservas=async()=>(await call('listarEventosReservas',{})).eventos;
